import PropTypes from 'prop-types'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Style } from '../../../../common/html/Style'
import { Element } from '../../../../common/html/element'
import { InputDropdown } from '../../../../common/html/input/InputDropdown'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { ScrollComponent } from '../../../../common/scrollComponent'
import TextEllipsis from '../../../../common/textEllipsis'
import EventEmitter, {
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { debounce } from '../../../../helpers/common'
import { selectCompanyInfo } from '../../header/companyInfo/store/slice'
import classes from './index.module.scss'
import { changeTypeTemplate } from './store/slice'

const InputSearchTemplate = ({
  callApiSearch,
  loadingSearch,
  dataTemplateSearch,
  nameKey,
  openTemplate,
  openMoreTemplate,
  style,
  isNotHasPermission,
  templateNameActive,
  setIsShowDetail,
  isOpenAll,
}) => {
  const dispatch = useDispatch()

  const companyInfo = useSelector(selectCompanyInfo)

  const plhSearch = UseI18n('preferenceSetting.SEARCH_TEMPLATE')

  const [isShowDropdown, setIsShowDropdown] = useState(false)
  const [value, setValue] = useState('')

  useEffect(() => {
    if (isShowDropdown) {
      callApiSearch(value.trim())
    }
  }, [isShowDropdown])

  useEffect(() => {
    if (templateNameActive) {
      setValue(templateNameActive || '')
    }
  }, [templateNameActive])

  const onChange = (e) => {
    setValue(e.target.value)
    callApi(e.target.value.trim())
  }

  const callApi = useCallback(
    debounce((value) => callApiSearch(value), 500),
    [],
  )

  const openMore = (templateType) => {
    setIsShowDropdown(false)
    openMoreTemplate(templateType)
    if (setIsShowDetail) {
      setIsShowDetail(false)
    }
    dispatch(changeTypeTemplate(templateType))
  }

  const open = (isActive, item) =>
    isActive
      ? () => {
          setValue(item[nameKey])
          openTemplate(item)
          setIsShowDropdown(false)
        }
      : undefined

  const openDropdown = () => {
    if (isNotHasPermission) {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    } else {
      setValue('')
      setIsShowDropdown(true)
    }
  }

  const clickOutside = () => {
    if (templateNameActive) {
      setValue(templateNameActive)
    }
    setIsShowDropdown(false)
  }

  return (
    <InputDropdown
      isShowDropdown={isShowDropdown}
      setIsShowDropdown={setIsShowDropdown}
      placeHolder={plhSearch}
      dropdownContentStyle={{ backgroundColor: '#F3F3F3' }}
      onClick={openDropdown}
      onClickOutsideDropdown={clickOutside}
      onChange={onChange}
      value={value || ''}
      style={style}
      scrollId={['companyAnalysis']}
    >
      <div className={classes.templateSearchContainer}>
        {loadingSearch ? (
          <Loading />
        ) : (
          <ScrollComponent autoHeight autoHeightMax={410}>
            {dataTemplateSearch.map(({ templateType, title, data }, index) => {
              const isActive =
                companyInfo.companyType === templateType || isOpenAll

              return (
                <Fragment key={templateType}>
                  <Element
                    className="fw600"
                    style={{
                      color: '#191D25',
                      marginTop: index ? '16px' : '0px',
                    }}
                  >
                    <Translate value={title} />
                  </Element>
                  <div className={`${classes.mt4} mb1`}>
                    <Style
                      className={classes.templateSearchItem}
                      pseudo="hover"
                      attr="background-color"
                      color="#c8e3ff"
                    />
                    {data.length ? (
                      data.map((item, index) => (
                        <Element
                          key={index}
                          className={classes.templateSearchItem}
                          onClick={open(isActive, item)}
                          style={{
                            color: !isActive ? '#9C9C9C' : undefined,
                            cursor: isActive ? 'pointer' : 'no-drop',
                          }}
                        >
                          <TextEllipsis
                            zIndexTooltip={14}
                            isI18n={false}
                            text={item[nameKey]}
                          />
                        </Element>
                      ))
                    ) : (
                      <Notification />
                    )}
                  </div>
                  <Element
                    onClick={() => openMore(templateType)}
                    style={{ color: '#2C73E8', cursor: 'pointer' }}
                  >
                    <Translate value="preferenceSetting.MORE_TEMPLATE" />
                  </Element>
                </Fragment>
              )
            })}
          </ScrollComponent>
        )}
      </div>
    </InputDropdown>
  )
}

InputSearchTemplate.propTypes = {
  callApiSearch: PropTypes.func.isRequired,
  loadingSearch: PropTypes.bool,
  dataTemplateSearch: PropTypes.arrayOf(
    PropTypes.shape({
      templateType: PropTypes.string,
      title: PropTypes.string,
      data: PropTypes.array,
    }),
  ).isRequired,
  nameKey: PropTypes.string.isRequired,
  openTemplate: PropTypes.func,
  openMoreTemplate: PropTypes.func,
  style: PropTypes.object,
  isNotHasPermission: PropTypes.bool,
  templateNameActive: PropTypes.string,
  isOpenAll: PropTypes.bool,
}

InputSearchTemplate.defaultProps = {
  openTemplate: () => {},
  openMoreTemplate: () => {},
  style: {},
  isNotHasPermission: false,
  isOpenAll: false,
}

export default InputSearchTemplate
